import { render, staticRenderFns } from "./ChannelAdd.vue?vue&type=template&id=7be45a04&scoped=true&"
import script from "./ChannelAdd.vue?vue&type=script&lang=js&"
export * from "./ChannelAdd.vue?vue&type=script&lang=js&"
import style0 from "./ChannelAdd.vue?vue&type=style&index=0&id=7be45a04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be45a04",
  null
  
)

export default component.exports